// A child's controls: their age band's preset, with the parent's changes folded in (each group
// replaced whole, in server order). Pure; see shared/controls.ts.
import type { ChildSettings } from '../../shared/controls'
import { t } from '../strings/en'

/**
 * The rules in plain words, one line per group that's set (B9, B10): what changed, for the note
 * a child sees, or all of them, for "My rules".
 */
export function describeRules(fields: Partial<ChildSettings>): string[] {
  const r = t.rules
  const out: string[] = []
  if (fields.learn) out.push(r.learn(fields.learn.goal, fields.learn.tracks.length, fields.learn.difficulty))
  if (fields.visibility) out.push(r.visibility[fields.visibility.mode]?.(fields.visibility.days) ?? fields.visibility.mode)
  if (fields.arcade) out.push(r.plays(fields.arcade.maxPlays))
  if (fields.canSuggest !== undefined) out.push(fields.canSuggest ? r.suggestOn : r.suggestOff)
  if (fields.canEdit) out.push(r.edit[fields.canEdit] ?? fields.canEdit)
  return out
}
// settingsFor moved to shared/controls.ts (the server's cron reads children's controls too).
export { settingsFor } from '../../shared/controls'
